import { ChangeDetectionStrategy, Component, computed, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { RankingByScope, SlotData } from 'src/app/gamification/services/models/ranking.model';
import { UserService } from 'src/app/services/user.service';
import { ConfigService } from 'src/app/services/config.service';
import { RankingScope } from 'src/app/models/client-configuration';
import { TabGroupComponent } from '../../../../../_shared/components/tab-group/tab-group.component';

@Component({
  selector: 'app-ranking',
  templateUrl: './ranking.component.html',
  styleUrls: ['./ranking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RankingComponent implements OnInit {
  @Input() ranking: RankingByScope;

  readonly RankingScope = RankingScope;
  readonly userService = inject(UserService);
  private readonly configService = inject(ConfigService);

  @ViewChild('tabGroup') tabGroup!: TabGroupComponent;

  readonly rankingScopeValues = RankingScope;
  readonly rankingScope = this.configService.get().gmfConfig.rankingScope;

  readonly defaultSelectTab = computed(() => this.rankingScope === RankingScope.PLATFORM ? 0 : 1);
  readonly platformSlots = computed(() => this.ranking[RankingScope.PLATFORM].slots);

  readonly slots = signal<SlotData[]>([]);
  readonly centerLabel = signal<string>('user.ranking.general.center');

  ngOnInit(): void {
    if (this.configService.isParana()) {
      this.centerLabel.set('user.ranking.general.class');
    }

    this.slots.set(this.ranking[this.rankingScope]?.slots);
  }

  changeSlot(rankingScope: RankingScope) {
    this.slots.set(this.ranking[rankingScope].slots);
  }

  refreshTabsIndicator() {
    this.tabGroup.refreshIndicatorPosition();
  }
}
